<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">
				<b-form-checkbox
					id="checkboxForUpperPartOfDoc"
					v-model="showUpperPartOfDoc"
					name="checkbox-1"
					class="mr-5"
					style="display: inline-block; cursor: pointer;"
				>
					Логотип и реквизиты
				</b-form-checkbox>

				<b-button
					variant="outline-primary"
					@click="excelSave"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>
				<!-- <a style="font-size: 16px;" class="mr-3" :href="`${root_api}/excel-parser/nakladnoy/optom/${saleForDocument.id}`" disabled
								download>{{ $t('excel-export.download-excel') }}</a> -->
				<!--<button id="btnExport" @click="fnExcelReport('tableForExcel')"> EXPORT </button>-->
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{ $t('Печать')}}
				</b-button>
			</div>
			<div class="clearfix"></div>


		</div>
		<div class="doc-body">
			<b-card class="p-1">
				<div id="docUpperPart" v-if="showUpperPartOfDoc">
					<div id="docUpperPartLeft">
						<img
							src="../../../../../public/img/nakladnoy_logo_2.jpg"
							alt=""
							id="docImgLogo"
						>
						<img
							src="../../../../../public/img/nakladnoy_logo_name.jpg"
							alt=""
							id="docImgLogoName"
						>
						<div id="docUpperPartTxt">
							<p>
								FACTURA FISCALĂ <br>
								НАЛОГОВАЯ НАКЛАДНАЯ
							</p>
							<p class="ml-4">
								<span>Seria, Nr.</span> <br>
								<span>Серия №</span>
							</p>
						</div>
						<div
							id="barcodeImgForSeria"
							v-if="seriaBarcodeConfirmed"
							@click="resetSeriaBarcodeInput"
						>
							<barcode :value="seriaForBarcodeGenerate" :options="{ height: '30px',displayValue: true, fontSize: 22}" tag="svg"></barcode>
						</div>
						<div id="seriaInputForBarcode" v-else>
							<input
								placeholder="Серия №"
								type="text"
								@keyup.enter="generateBarcodeForSeria"
							>
						</div>
					</div>
					<div id="docUpperPartRight">
						<p id="rightPartTxt">
							Formular tipizat
							Anexa nr. 1la Ordinul Ministeruliu Finanțelor al Republicii Moldova nr. 118 din 28 august 2017
							Типовая форма
							Приложение №1 к Приказу Министерства финансов  Республике молдова № 118 от 28 август 2017г.
						</p>
					</div>
				</div>
				<div class="mb-3" id="nakladnoyTableWrapper" :class="[showUpperPartOfDoc ? '' : 'hasMarginTop']">
					<table class="table table-striped" id="tableForExcel">
						<thead>
						<tr>
							<th class="p-1 borderRightNone" rowspan="2" colspan="2">
								<span class="moldavianText nobr" style="font-weight: bold">Data eliberării / data livrării </span>
								<br>
								<span class="fontWeightNormal nobr">Дата выписки / дата поставки</span>
							</th>
							<td class="p-1 borderLeftNone nobr textAlignCenter" rowspan="2" colspan="3">
											<div style="display: flex;flex-direction: row">
												<!-- <p  style="border-bottom: 1px solid black;"
													class="bottomBorderedInput width80">{{saleForDocument.saleDate}}</p> /


												<p  style="border-bottom: 1px solid black;width: 33%; "
													class="bottomBorderedInput width70"> </p> -->
												<div  style="border-bottom: 1px solid black;"  @click="changePunctFive('0202')"
													class="bottomBorderedInput width80">
														<tag
														style="width: 100%; " ref="regDateRef"
														@blur.native="blurFivePunct('0202',
														saleForDocument)"
														mask="11-11-1111"
														v-model="saleForDocument.saleDate"
														:value="saleForDocument.saleDate"
														:class="tag0202 == 'input' ? 'bg-light' : 'bg-white'"
														:is="tag0202">{{saleForDocument.saleDate}}</tag>
												</div> /


												<div  style="border-bottom: 1px solid black;width: 33%; "
													class="bottomBorderedInput width70"  @click="changePunctFive('0101')">
														<tag
														style="width: 100%; " ref="date2Ref"
														@blur.native="blurFivePunct('0101',
														saleForDocument)"
														mask="11-11-1111"
														v-model="saleForDocument.date2"
														:value="saleForDocument.date2"
														:class="tag0101 == 'input' ? 'bg-light' : 'bg-white'"
														:is="tag0101">{{saleForDocument.date2}}</tag>
												</div>
											</div>


							</td>
							<td class="p-1 borderRightNone nobr" >
								<span class="moldavianText" style="font-weight: bold">8. Foaia de parcurs </span><br>
								<span class="fontWeightNormal">Путевой лист</span>
							</td>
							<td @click="changePunctFive('81')" class="p-1 borderRightNone borderLeftNone">
								<tag
								  style="width: 100%; " class="p-1" ref="waybillRef"
								  @blur="blurFivePunct('81',
								 saleForDocument)"
								  v-model="saleForDocument.waybill"
								  :value="saleForDocument.waybill"
								  :class="tag81 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag81">{{saleForDocument.waybill}}</tag>
							</td>
							<td class="p-1 borderRightNone borderLeftNone textAlignCenter">
								<span class="moldavianText" style="font-weight: bold">seria:</span>
								<br>
								<span class="fontWeightNormal">серия</span>
							</td>
							<td @click="changePunctFive('82')"  class="p-1 borderRightNone borderLeftNone">
								<tag
								  style="width: 100%;" class="p-1" ref="seriaRef"
								  @blur="blurFivePunct('82',
								 saleForDocument)"
								  v-model="saleForDocument.seria"
								  :value="saleForDocument.seria"
								  :class="tag82 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag82">{{saleForDocument.seria}}</tag>
								  <br>
								<div style="display: inline-block">
									<h6 style="border-bottom: 1px solid black;"
										class="bottomBorderedInput width70"></h6>
								</div>
							</td>
							<td class="p-1 borderRightNone borderLeftNone textAlignCenter">
								<span class="moldavianText" style="font-weight: bold">număr:</span>
								<br>
								<span class="fontWeightNormal">номер</span>
							</td>
							<td class="p-1 borderRightNone borderLeftNone">
								<div style="display: inline-grid">
									<h6 style="border-bottom: 1px solid black;"
										class="bottomBorderedInput width70"></h6>
								</div>
							</td>
							<td class="p-1 borderLeftNone borderRightNone textAlignCenter" colspan="2">
								<span class="moldavianText" style="font-weight: bold">data</span>
								<br>
								<span class="fontWeightNormal">дата</span>
							</td>
							<td @click="changePunctFive('83')" class="p-1 borderLeftNone">
								<tag
								  style="width: 100%;" class="p-1" ref="nakladnoyDateRef"
								  @blur="blurFivePunct('83',
								 saleForDocument)"
								  v-model="saleForDocument.nakladnoyDate"
								  :value="saleForDocument.nakladnoyDate"
								  :class="tag83 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag83">{{saleForDocument.nakladnoyDate}}</tag>
								  <br>
								<div style="display: inline-block">
									<h6 style="border-bottom: 1px solid black;"
										class="bottomBorderedInput width70"></h6>
								</div>
							</td>
						</tr>
						<tr>
							<td class="p-1 borderRightNone nobr">
								<span class="moldavianText" style="font-weight: bold">9. Transportator</span><br>
								<span class="fontWeightNormal">Перевозчик</span>
							</td>
							<td  @click="changePunctFive('9')" class="p-1 borderLeftNone" colspan="4">
								<tag
								  style="width: 100%" class="p-1" ref="transportatorRef"
								  @blur="blurFivePunct('9',
								  saleForDocument)"
								  v-model="saleForDocument.transportator"
								  :value="saleForDocument.transportator"
								  :class="tag9 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag9">{{saleForDocument.transportator}}</tag>
							</td>
							<td class="p-1 borderRightNone">
								<span class="moldavianText" style="font-weight: bold">c.f./ nr. TVA</span><br>
								<span class="fontWeightNormal">ф.к./ код НДС</span>
							</td>
							<td @click="changePunctFive('ndsTranspartor')" class="p-1 borderLeftNone fontWeightNormal textAlignCenter" colspan="3">
								<tag
								  style="width: 100%" class="p-1" ref="ndsTranspartorRef"
								  @blur="blurFivePunct('ndsTranspartor',
								  saleForDocument)"
								  v-model="saleForDocument.ndsTranspartor"
								  :value="saleForDocument.ndsTranspartor"
								  :class="tagNdsTranspartor == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tagNdsTranspartor">{{saleForDocument.ndsTranspartor}}</tag>
							</td>
						</tr>
						<tr>
							<td class="p-1 borderRightNone">
								<span class="moldavianText" style="font-weight: bold">1. Furnizor:</span><br>
								<span class="fontWeightNormal">Поставщик</span>
							</td>
							<td class="p-1 borderLeftNone fontWeightNormal" colspan="9">
								<span>
									{{ saleForDocument.shopName }}, {{ saleForDocument.shopAddress }},
									{{ saleForDocument.shopBankAccount }}
								</span>
							</td>
							<td class="p-1 borderRightNone">
								<span class="moldavianText" style="font-weight: bold">c.f./ nr. TVA</span><br>
								<span class="fontWeightNormal">ф.к./ код НДС</span>
							</td>
							<td class="p-1 borderLeftNone textAlignCenter" colspan="3">
								<span class="fontWeightNormal">
									{{ saleForDocument.shopVatAccount }}
								</span>
							</td>
						</tr>
						<tr>
							<td class="p-1 borderRightNone">
								<span class="moldavianText nobr" style="font-weight: bold">2. Cumparator/beneficiar:</span><br>
								<span class="fontWeightNormal">Покупатель/получатель</span>
							</td>
							<td class="p-1 borderLeftNone fontWeightNormal" colspan="9">
								<span>
									{{ saleForDocument.contragentName }}, {{ saleForDocument.contragentAddress }},
									{{ saleForDocument.contragentBankAccount }}
								</span>
							</td>
							<td class="p-1 borderRightNone">
								<span class="moldavianText" style="font-weight: bold">c.f./ nr. TVA</span><br>
								<span class="fontWeightNormal">ф.к./ код НДС</span>
							</td>
							<td class="p-1 borderLeftNone textAlignCenter" colspan="3">
								<span class="fontWeightNormal">
									{{ saleForDocument.contragentVatAccount }}
								</span>
							</td>
						</tr>
						<tr>
							<td class="p-1 borderRightNone" colspan="2">
								<span class="moldavianText nobr" style="font-weight: bold">3. Delegație</span><br>
								<span class="fontWeightNormal">Доверенность</span>
							</td>
							<td  @click="changePunctFive('31')" class="p-1 borderLeftNone fontWeightNormal borderRightNone" colspan="2">
								<tag
								  style="width: 100%" class="p-1" ref="nakladnoyPowerOfAttorneyRef"
								  @blur="blurFivePunct('31',
								  saleForDocument)"
								  v-model="saleForDocument.nakladnoyPowerOfAttorney"
								  :value="saleForDocument.nakladnoyPowerOfAttorney"
								  :class="tag31 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag31">{{saleForDocument.nakladnoyPowerOfAttorney}}</tag>
							</td>
							<td class="p-1 borderRightNone borderLeftNone">
								<span class="moldavianText" style="font-weight: bold">data</span>
								<br>
								<span class="fontWeightNormal">дата</span>
							</td>
							<td  @click="changePunctFive('32')"  class="p-1 borderLeftNone fontWeightNormal borderRightNone">
								<tag
								  style="width: 100%" class="p-1" ref="nakladnoyDelegateDateRef"
								  @blur="blurFivePunct('32',
								 saleForDocument)"
								  v-model="saleForDocument.nakladnoyDelegateDate"
								  :value="saleForDocument.nakladnoyDelegateDate"
								  :class="tag32 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag32">{{saleForDocument.nakladnoyDelegateDate}}</tag>
							</td>
							<td class="p-1 borderRightNone borderLeftNone">
								<span class="moldavianText" style="font-weight: bold">delegatul</span>
								<br>
								<span class="fontWeightNormal">делегированный</span>
							</td>
							<td  @click="changePunctFive('33')" class="p-1 borderLeftNone fontWeightNormal" colspan="2">
								<tag
								  style="width: 100%" class="p-1" ref="nakladnoyDelegateRef"
								  @blur="blurFivePunct('33',
								 saleForDocument)"
								  v-model="saleForDocument.nakladnoyDelegate"
								  :value="saleForDocument.nakladnoyDelegate"
								  :class="tag33 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag33">{{saleForDocument.nakladnoyDelegate}}</tag>
							</td>
							<td class="p-1 borderRightNone nobr" colspan="2">
								<span class="moldavianText" style="font-weight: bold">4. Documente anexate</span><br>
								<span class="fontWeightNormal">Прилагаемые документы</span>
							</td>
							<td @click="changePunctFive('4')" class="p-1 borderLeftNone fontWeightNormal textAlignCenter" colspan="3">
								<tag
								  style="width: 100%" class="p-1" ref="fourRef"
								  @blur="blurFivePunct('4',
								  saleForDocument)"
								  v-model="saleForDocument.nakladnoyAttachedDocs"
								  :value="saleForDocument.nakladnoyAttachedDocs"
								  :class="tag4 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag4">{{saleForDocument.nakladnoyAttachedDocs}}</tag>
							</td>
						</tr>
						<tr>
							<td class="p-1 borderRightNone">
								<span class="moldavianText nobr" style="font-weight: bold">5. Punct încărcare</span><br>
								<span class="fontWeightNormal">Пункт погрузки</span>
							</td>
							<td @click="changePunctFive('5')" class="p-1 borderLeftNone fontWeightNormal borderRightNone" colspan="4">
								  <tag
								  style="width: 100%;" class="p-1" ref="fiveRef"
								  @blur="blurFivePunct('5', saleForDocument)"
								  v-model="saleForDocument.loadingPoint"
								  :value="saleForDocument.loadingPoint"
								  :class="tag5 == 'input' ? 'bg-light' : 'bg-white'"
								  :is="tag5">{{saleForDocument.loadingPoint}}</tag>
							</td>
							<td class="p-1 borderRightNone nobr">
								<span class="moldavianText" style="font-weight: bold">6. Punct descărcare</span><br>
								<span class="fontWeightNormal">Пункт разгрузки</span>
							</td>
							<td  @click="changePunctFive('6')" class="p-1 borderLeftNone fontWeightNormal textAlignCenter" colspan="4">
								<tag style="width: 70%;" class="p-1" ref="sixRef"
								:class="tag6 == 'input' ? 'bg-light' : 'bg-white'"
								  v-model="saleForDocument.unloadingPoint"
								  :value="saleForDocument.unloadingPoint"
								  @blur="blurFivePunct('6',

								  saleForDocument)"
								  :is="tag6">{{saleForDocument.unloadingPoint}}</tag>
							</td>
							<td class="p-1 borderRightNone nobr">
								<span class="moldavianText" style="font-weight: bold">7. Redirijări</span><br>
								<span class="fontWeightNormal">Переадресовки</span>
							</td>
							<td  @click="changePunctFive('7')" class="p-1 borderLeftNone fontWeightNormal textAlignCenter" colspan="3">
								 <tag style="width: 100%;" class="p-1" ref="sevenRef"
								 :class="tag7 == 'input' ? 'bg-light' : 'bg-white'"
									:value="saleForDocument.redirects"
									v-model="saleForDocument.redirects"
								  @blur="blurFivePunct('7',
								  saleForDocument)"
								  :is="tag7">{{saleForDocument.redirects}}</tag>
							</td>
						</tr>
						<tr id="moldavianItemsHeader">
							<td class="p-1 textAlignCenter width27" colspan="3">
								<span class="moldavianText customSize " style="font-weight: bold">10.1</span><br>
								<span class="moldavianText customSize" style="font-weight: bold">Denumirea marfurilor/activelor, serviciilor si codul
									<br>pozitiei tarifare al marfii/activului
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.2</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Unitatea de măsură
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.3</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Cantitatea marfurilor/activelor, volumul serviciilor
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span style="font-weight: bold" class="moldavianText customSize">10.4</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Preț unitar, fără TVA, lei
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.5</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Valoarea totală fără TVA, lei
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span style="font-weight: bold" class="moldavianText customSize">10.6</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Cota TVA, %
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.7</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Suma totală a TVA, lei
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.8</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Valoarea mărfurilor/activelor, serviciilor, lei
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.9</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Altă informație
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span style="font-weight: bold" class="moldavianText customSize">10.10</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Tip ambalaj
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.11</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Număr locuri
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="moldavianText customSize" style="font-weight: bold">10.12</span><br>
								<span style="font-weight: bold" class="moldavianText customSize">
									Masa brută, tone
								</span>
							</td>
						</tr>
						<tr id="russianItemsHeader">
							<td class="p-1 textAlignCenter customSize" colspan="3">
								<span class="greyText">
									Наименование товаров/активов, услуг и код
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Единица измерения
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Количество товаров/активов, объем услуг
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Цена единицы без НДС, леев
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Общая сумма без НДС, леев
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Ставка НДС, %
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Общая сумма НДС, леев
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Cтоимость товаров/активов, услуг, леев
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Другая информация
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Тип упаковки
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Количество мест
								</span>
							</td>
							<td class="p-1 textAlignCenter">
								<span class="greyText customSize">
									Масса брутто, тонн
								</span>
							</td>
						</tr>
						</thead>
						<tbody>
						<tr v-for="(item, index) in saleForDocument.saleItems" class="docItemRow" :key="index">
							<td colspan="3" class="customSizeItem">
								{{ item.name.substring(0, 30) }} / <strong>{{ item.barcode }}</strong> / {{ item.size }}
							</td>
							<td class="docItemUnit customSizeItem">
								{{ item.unitName }}
							</td>
							<td class="customSizeItem">
								{{ item.count }}
							</td>
							<td class="customSizeItem">
								{{ calculatePriceWithoutNds(item) | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
							</td>
							<td>
								<span v-if="item.priceWholesale" class="customSizeItem">{{ calculateSumOfItemWithoutNds(item) | currency({
											symbol: ' ', fractionCount: 2, symbolPosition: 'back'
											}) }}</span>
								<span v-else> </span>
							</td>
							<td>
								20%
							</td>
							<td>
								<span v-if="calculateRealCostOfItem(item) > 0" class="customSizeItem">{{ calculateNdsOfItem(item) | currency({
											symbol: ' ', fractionCount: 2, symbolPosition: 'back'
											}) }}</span>
								<span v-else> </span>
							</td>
							<td>
								<span v-if="calculateRealCostOfItem(item) > 0" class="customSizeItem">
									{{ calculateRealCostOfItem(item) | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span v-else> </span>
							</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						</tbody>
						<tfoot>
						<tr>
							<td colspan="6" style="font-weight: bold">
								11. TOTAL (pe pagină) / Всего (по странице)
							</td>
							<td>
								<span v-if="totalPriceOfItems > 0" style="font-weight: bold">
									{{ totalPriceOfItems | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span> </span>
							</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td>
								<span v-if="totalNdsOfItems > 0" style="font-weight: bold">
									{{ totalNdsOfItems | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span> </span>
							</td>
							<td>
								<span v-if="calculateTotalRealCost() > 0" style="font-weight: bold">
									{{ calculateTotalRealCost() | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span v-else> </span>
							</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td></td>
						</tr>

						<tr>
							<td colspan="6" style="font-weight: bold">
								12. TOTAL (pe factura fiscală) / Всего (по налоговой накладной)
							</td>
							<td>
								<span v-if="totalPriceOfItems > 0" style="font-weight: bold">
									{{ totalPriceOfItems | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span> </span>
							</td>
							<td class="textAlignCenter">x
							</td>
							<td>
								<span v-if="totalNdsOfItems > 0" style="font-weight: bold">
									{{ totalNdsOfItems | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span> </span>
							</td>
							<td>
								<span v-if="calculateTotalRealCost() > 0" style="font-weight: bold">
									{{ calculateTotalRealCost() | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
								<span v-else> </span>
							</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td class="textAlignCenter" style="font-weight: bold">x</td>
							<td></td>
						</tr>

						<tr>
							<td class="borderRightNone borderBottomNone" colspan="5">
								<span class="moldavianText nobr" style="font-weight: bold">13. Permis eliberarea:</span><br>
								<span class="fontWeightNormal">Отпуск разрешил</span>
							</td>
							<td class="borderLeftNone fontWeightNormal" colspan="9">

							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderTopNone borderBottomNone" colspan="5">

							</td>
							<td class="borderLeftNone borderBottomNone fontWeightNormal textAlignCenter" colspan="9">
								<span class="moldavianText nobr" style="font-weight: bold">Funcția, numele, prenumele și semnătura</span><br>
								<span class="fontWeightNormal">Должность, фамилия, имя и подпись</span>
							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderBottomNone" colspan="5">
								<span class="moldavianText nobr" style="font-weight: bold">14. Predat marfurile/activele (serviciile):</span><br>
								<span class="fontWeightNormal">Сдал товары/активы (услуги)</span>
							</td>
							<td class="borderLeftNone fontWeightNormal" colspan="9">

							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderTopNone borderBottomNone" colspan="5">
								<span class="moldavianText nobr" style="font-weight: bold">
									L.S.
								</span><br>
								<span class="fontWeightNormal">
									М.П.
								</span>
							</td>
							<td class="borderLeftNone borderBottomNone fontWeightNormal textAlignCenter" colspan="9">
								<span class="moldavianText nobr" style="font-weight: bold">Funcția, numele, prenumele și semnătura</span><br>
								<span class="fontWeightNormal">Должность, фамилия, имя и подпись</span>
							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderBottomNone" colspan="5">
								<span class="moldavianText nobr" style="font-weight: bold">15. Primit marfurile/activele intermediarul (transportatorul):</span><br>
								<span class="fontWeightNormal">Принял товары/активы посредник (перевозчик)</span>
							</td>
							<td class="borderLeftNone fontWeightNormal" colspan="9">

							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderTopNone borderBottomNone" colspan="5">

							</td>
							<td class="borderLeftNone borderBottomNone fontWeightNormal textAlignCenter" colspan="9">
								<span class="moldavianText nobr" style="font-weight: bold">Funcția, numele, prenumele și semnătura</span><br>
								<span class="fontWeightNormal">Должность, фамилия, имя и подпись</span>
							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderBottomNone" colspan="5">
								<span class="moldavianText nobr" style="font-weight: bold">16. Predat marfurile/activele intermediarul (transportatorul):</span><br>
								<span class="fontWeightNormal">Сдал товары/активы посредник (перевозчик)</span>
							</td>
							<td class="borderLeftNone fontWeightNormal" colspan="9">

							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderTopNone borderBottomNone" colspan="5">

							</td>
							<td class="borderLeftNone borderBottomNone fontWeightNormal textAlignCenter" colspan="9">
								<span class="moldavianText nobr" style="font-weight: bold">Funcția, numele, prenumele și semnătura</span><br>
								<span class="fontWeightNormal">Должность, фамилия, имя и подпись</span>
							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderBottomNone" colspan="5">
								<span class="moldavianText nobr" style="font-weight: bold">17. Primit marfurile/activele (serviciile) cumparatorul/beneficiarul:</span><br>
								<span
									class="fontWeightNormal">Принял товары/активы (услуги) покупатель/получатель</span>
							</td>
							<td class="borderLeftNone fontWeightNormal borderRightNone" colspan="7">

							</td>
							<td class="borderLeftNone fontWeightNormal borderBottomNone" colspan="2">

							</td>
						</tr>
						<tr>
							<td class="borderRightNone borderTopNone" colspan="5">

							</td>
							<td class="borderLeftNone fontWeightNormal textAlignCenter borderRightNone"
								style="padding-left: 11.8%;" colspan="7">
								<span class="moldavianText nobr" style="font-weight: bold">Funcția, numele, prenumele și semnătura</span><br>
								<span class="fontWeightNormal">Должность, фамилия, имя и подпись</span>
							</td>
							<td class="borderLeftNone fontWeightNormal borderTopNone textAlignLeftImportant"
								colspan="2">
								<span class="moldavianText nobr pl-3">
									L.S.
								</span><br>
								<span class="fontWeightNormal pl-3">
									М.П.
								</span>
							</td>
						</tr>
						</tfoot>
					</table>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
	import {mapActions, mapState} from 'vuex'
	import WhDocument from "../../../../services/wh-document.service";
	import MaskedInput from 'vue-masked-input'

	export default {
		name: 'Nakladnoy',
		render(h) {
			return h(this.tag, this.is)
		},
		components: {
			MaskedInput
		},
		data() {
			return {
				showUpperPartOfDoc: true,
				seriaBarcodeConfirmed: false,
				seriaForBarcodeGenerate: '',
				root_api: process.env.VUE_APP_ROOT_API,
				currentContragentForTransfer: {},
				currentDepartmentForMoneyTransfer: {},
				saldoByYear: {
					currentYear: {},
					lastYear: {},
					totalSaldo: {}
				},
				item: {},
				totalPrice: {
					uzs: 0,
					usd: 0
				},
				priceType: 'uzs',
				income: [],
				totalIncome: {
					uzs: 0,
					usd: 0
				},
				sidebar: {
					open: false,
					close: false
				},
				backTo: null,
				tag5: 'span',
				tag6: 'span',
				tag7: 'span',
				tag4:'span',
				tag81:'span',
				tag82:'span',
				tag83:'span',
				tag9:'span',
				tagNdsTranspartor: 'span',
				tag31:'span',
				tag32:'span',
				tag33:'span',
				tag0101:'span',
				tag0202:'span'
			}
		},

		methods: {
			resetSeriaBarcodeInput () {
				this.seriaBarcodeConfirmed = false;
			},
			generateBarcodeForSeria($event) {
				if ($event.target.value.trim() == '') {
					return 0;
				}
				this.seriaForBarcodeGenerate = $event.target.value
				this.seriaBarcodeConfirmed = true;
			},
			async excelSave() {
				let res = await WhDocument.excelNakladnoyOptom(this.$route.params.id, this.saleForDocument, "MOLDOVA")
				const url = URL.createObjectURL(new Blob([res.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				}))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', 'excel-file')
				document.body.appendChild(link)
				link.click()
			},
			async blurFivePunct(number, payload) {
			switch(number) {
				case '5':
				payload.loadingPoint = this.$refs.fiveRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag5 = 'span'
				break;
				case '6':
				payload.unloadingPoint = this.$refs.sixRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag6 = 'span'
				break;
				case '7':
				payload.redirects = this.$refs.sevenRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag7 = 'span'
				break;
				case '4':
				payload.nakladnoyAttachedDocs = this.$refs.fourRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag4 = 'span'
				break;
				case '82':
				payload.seria = this.$refs.seriaRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag82 = 'span'
				break
				case '81':
				payload.waybill = this.$refs.waybillRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag81 = 'span'
				break
				case '83':
				payload.nakladnoyDate = this.$refs.nakladnoyDateRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag83 = 'span'
				break;
				case '9':
				payload.transportator = this.$refs.transportatorRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag9  = 'span'
				break;
				case 'ndsTranspartor':
				payload.ndsTranspartor = this.$refs.ndsTranspartorRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tagNdsTranspartor  = 'span'
				break;
				case '31':
				payload.nakladnoyPowerOfAttorney = this.$refs.nakladnoyPowerOfAttorneyRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag31  = 'span'
				break;
				case '32':
				payload.nakladnoyDelegateDate = this.$refs.nakladnoyDelegateDateRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag32  = 'span'
				break;
				case '33':
				payload.nakladnoyDelegate = this.$refs.nakladnoyDelegateRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag33  = 'span'
				break
				case '0101':
				payload.date2 = this.$refs.date2Ref.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag0101  = 'span'
				break

				case '0202':
				payload.saleDate = this.$refs.regDateRef.value;
				await WhDocument.editWholeSaleDoc(this.$route.params.id, payload)
				await this.getSaleById(this.$route.params.id)
				this.tag0202  = 'span'
				break
				}
			},
			changePunctFive(number) {
			switch(number) {
				case '5':
					if(this.tag5 !== 'input') {
						this.tag5 = 'input'
						setTimeout(() => {
						this.$refs.fiveRef.focus()
						}, 100)
					}
				break;
				case '6':
					if(this.tag6 !== 'input') {
						this.tag6 = 'input'
						setTimeout(() => {
					this.$refs.sixRef.focus()
						}, 100)
					}
				break;
				case '7':
					if(this.tag7 !== 'input') {
						this.tag7 = 'input'
						setTimeout(() => {
						this.$refs.sevenRef.focus()
						}, 100)
					}
				break;
				case '4':
					if(this.tag4 !== 'input') {
						this.tag4 = 'input'
						setTimeout(() => {
						this.$refs.fourRef.focus()
						}, 100)
					}
				break;

				case '81':
					if(this.tag81 !== 'input') {
						this.tag81 = 'input'
						setTimeout(() => {
						this.$refs.waybillRef.focus()
						}, 100)
					}
				break;

				case '82':
					if(this.tag82 !== 'input') {
						this.tag82 = 'input'
						setTimeout(() => {
						this.$refs.seriaRef.focus()
						}, 100)
					}
				break;

				case '83':
					if(this.tag83 !== 'input') {
						this.tag83 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyDateRef.focus()
						}, 100)
					}
				break;
				case '9':
					if(this.tag9 !== 'input') {
						this.tag9 = 'input'
						setTimeout(() => {
						this.$refs.transportatorRef.focus()
						}, 100)
					}
				break;
				case 'ndsTranspartor':
					if(this.tagNdsTranspartor !== 'input') {
						this.tagNdsTranspartor = 'input'
						setTimeout(() => {
							this.$refs.ndsTranspartorRef.focus()
						}, 100)
					}
				break;
				case '31':
					if(this.tag31 !== 'input') {
						this.tag31 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyPowerOfAttorneyRef.focus()
						}, 100)
					}
				break;
				case '32':
					if(this.tag32 !== 'input') {
						this.tag32 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyDelegateDateRef.focus()
						}, 100)
					}
				break;
				case '33':
					if(this.tag33 !== 'input') {
						this.tag33 = 'input'
						setTimeout(() => {
							this.$refs.nakladnoyDelegateRef.focus()
						}, 100)
					}
				break;
				case '0101':
					if(this.tag0101 !== 'masked-input') {
						this.tag0101 = 'masked-input'
						setTimeout(() => {
							this.$refs.date2Ref.$el.focus()
						}, 100)
					}
				break;
				case '0202':
					if(this.tag0202 !== 'masked-input') {
						this.tag0202 = 'masked-input'
						setTimeout(() => {
							this.$refs.regDateRef.$el.focus()
						}, 100)
					}
				break;
			}
		},
			...mapActions('wholesalePos', [
				'getSaleById'
			]),
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},

			tableToExcel(tableID) {
				var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
				var textRange = "<p text-align=''";
				var j = 0;
				let tab = document.getElementById(tableID); // id of table

				for (j = 0; j < tab.rows.length; j++) {
					tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
					//tab_text=tab_text+"</tr>";
				}

				tab_text = tab_text + "</table>";
				tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
				tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
				// tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

				var ua = window.navigator.userAgent;
				var msie = ua.indexOf("MSIE ");

				if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
				{
					txtArea1.document.open("txt/html", "replace");
					txtArea1.document.write(tab_text);
					txtArea1.document.close();
					txtArea1.focus();
					var sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
				} else                 //other browser not tested on IE 11
					sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

				return (sa);
			},


			excelExport(tableID, filename = '') {

				let downloadLink;

				let dataType = 'text/xls;charset=UTF-8';
				//var dataType = 'application/vnd.ms-excel';
				let tableSelect = document.getElementById(tableID);
				let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

				// Specify file name
				filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';
				// Create download link element
				downloadLink = document.createElement("a");

				document.body.appendChild(downloadLink);

				if (navigator.msSaveOrOpenBlob) {
					let blob = new Blob(['\ufeff', tableSelect], {
						encoding: "utf-8",
						type: dataType
					});
					navigator.msSaveOrOpenBlob(blob, filename);
				} else {
					// Create a link to the file
					downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

					// Setting the file name
					downloadLink.download = filename;

					//triggering the function
					downloadLink.click();
				}
			},
			calculateRealCostOfItem(item) {
				/*let sumOfPriceWithoutNds = (item.priceWholesale/1.2) * item.count;
                let sumOfNds = ((item.priceWholesale * item.count) * 0.2)/1.2;*/
				if (item.discountPriceUzs > 0) {
					return item.discountPriceUzs * item.count;
				} else {
					return 0
				}
			},
			calculateNdsOfItem(item) {
				return this.calculateRealCostOfItem(item) / 6;
			},
			calculateSumOfItemWithoutNds(item) {
				return this.calculateRealCostOfItem(item) - this.calculateNdsOfItem(item);
			},
			calculatePriceWithoutNds(item) {
				return this.calculateSumOfItemWithoutNds(item) / item.count;
			},
			calculateTotalRealCost() {
				let temp = 0;
				for (let i = 0; i < this.saleForDocument.saleItems.length; i++) {
					temp += this.calculateRealCostOfItem(this.saleForDocument.saleItems[i]);
				}
				return temp;
			}
		},
		async created() {
			await this.getSaleById(this.$route.params.id);
		},
		computed: {
			...mapState('wholesalePos', [
				'saleForDocument'
			]),
			totalPriceOfItems() {
				let temp = 0;
				this.saleForDocument.saleItems.forEach(el => {
					temp += this.calculateSumOfItemWithoutNds(el);
				});
				return temp;
			},
			totalNdsOfItems() {
				let temp = 0;
				this.saleForDocument.saleItems.forEach(el => {
					temp += this.calculateNdsOfItem(el);
				});
				return temp;
			}
		},
	}
</script>

<style scoped lang="scss">
	.nakladnoyWholesale {
		margin: 0 20px;
	}

	@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
		#nakladnoyTableWrapper {
			&.hasMarginTop {
				margin-top: 4cm;
			}
			display: block;
		}
	}

	.saldoInfoTexts {
		width: 88%;

		span {
			display: inline-block;
			width: 18%;
		}

		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 80%;
		}

		/*input.bottomBorderedInput:focus {
		border-color: green
		}*/
	}


	.signsOfAccountants {
		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 40%;
		}

		p {
			width: 40%;

			&.sign {
				text-align: center;
				font-size: 12px;
			}
		}
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.width70 {
			width: 70px;
		}

		&.width80 {
			width: 80px;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	h6.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.width70 {
			width: 70px;
		}

		&.width80 {
			width: 80px;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	#nakladnoyTableWrapper {
		.table {
			td, th {
				border: 1px solid black;
				vertical-align: middle;

				&.borderRightNone {
					border-right: none;
				}

				&.borderLeftNone {
					border-left: none;
				}

				&.borderTopNone {
					border-top: none;
				}

				&.borderBottomNone {
					border-bottom: none;
				}

				color: black;
			}

			#moldavianItemsHeader {
				th {
					font-size: 9px;
					border-bottom: none;
				}
				.width27 {
					width: 27%;
				}
			}

			#russianItemsHeader {
				th {
					font-size: 9px;
					border-top: none;
				}

				.greyText {
					color: #999999;
				}
			}

			.docItemRow {
				td {
					text-align: right;

					&.docItemUnit {
						text-align: center;
					}

					&:first-child {
						text-align: unset;
					}

					padding: 0 .5rem;
				}
			}

			th {
				font-size: 11px;
			}



			.moldavianText {
				font-weight: bold;
			}

			.fontWeightNormal {
				font-weight: normal;
			}

			tfoot {
				th, td {
					font-weight: bold;
					font-size: 12px;
					text-align: right;

					&.textAlignCenter {
						text-align: center;
					}

					&:first-child {
						text-align: unset;
					}

					padding: 0 .5rem;
				}
			}
		}
	}
	.customSize{
		font-size: 10px;
	}
	.customSizeItem{
		font-size: 12px;
	}
	.nobr {
		white-space: nowrap;
	}

	.strong {
		font-weight: bold;
	}

#docUpperPart {
	p {
		margin-bottom: 0;
	}
	margin-bottom: .5rem;
	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}
	#docImgLogo {
		width: 180px;
		height: 70px;
	}
	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;
			p {
				display: inline-block;
			}
		}
		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;
			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;
				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}
		display: inline-block;
		width: 74%;
		#seriaInputForBarcode {
			display: inline-block;
			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}
	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;
		#rightPartTxt {
			font-size: 10px;
		}
	}
}
</style>
